<script>
import moment from 'moment'
import config from '../../config'
import { mapGetters } from 'vuex'

const baseUrl = config.baseUrl
const wikiUrl = config.wikiUrl
export default {
  name: 'Common',
  computed: {
    ...mapGetters({
      storeUserPermissions: 'userPermissions',
      storeUser: 'user'
    })
  },
  methods: {
    upperFirstCase (string) {
      return string[0].toUpperCase() +
          string.slice(1)
    },
    checkPermissionUser (per) {
      return true
      if (this.storeUser.role === 'AllergyClinic') {
        return true
      }
      return this.storeUserPermissions.indexOf(per) > -1
    },
    chunkArray (myArray, chunk_size) {
      let index = 0
      let arrayLength = myArray.length
      let tempArray = []

      for (index = 0; index < arrayLength; index += chunk_size) {
        let myChunk = myArray.slice(index, index + chunk_size)
        // Do something if you want with the group
        tempArray.push(myChunk)
      }

      return tempArray
    },
    formatColorRate (number) {
      if (number) {
        let arrStr = String(number).split(':')
        if (arrStr.length > 1) {
          let val = Number(arrStr[1])
          if (val > 999) {
            arrStr[1] = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return arrStr.join(':')
          }
        }
        let val = Number(number)
        if (val > 999) {
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
      }
      return number
    },
    zeroPadded (num) {
      // 4 --> 04
      return num < 10 ? `0${num}` : num
    },
    showAddress (patient) {
      let address = ''
      if (patient.address) {
        address = patient.address
      } else {
        address = patient.streetNumber + (patient.streetName ? ' ' + patient.streetName : '') + (patient.suite ? ', ' + patient.suite : '')
      }
      return address +
          (patient.city ? ', ' + patient.city : '') +
          (patient.state ? ', ' + patient.state : '') +
          (patient.zipCode ? ', ' + patient.zipCode : '')
    },
    showPetPatient (patient) {
      let pets = (patient) ? patient.pets : null
      if (pets) {
        return pets.join(', ')
      }
      return ''
    },
    getLinkAvatarWiki (link) {
      return wikiUrl + link
    },
    alertError (msg, title) {
      this.$store.commit('setAlertMessage', { type: 'error', title: title || 'Error', open: true, msg: msg })
    },
    alertSuccess (msg, title) {
      this.$store.commit('setAlertMessage', {
        type: 'success',
        title: title || 'Success',
        open: true,
        msg: msg
      })
    },
    showLoading (status) {
      this.$store.commit('setShowLoadingScreen', status)
    },
    formatBirthday (patient) {
      if (patient.month !== undefined && patient.day !== undefined && patient.year !== undefined) {
        let month = patient.month
        if (patient.month < 10) {
          month = '0' + patient.month
        }
        let day = patient.day
        if (patient.day < 10) {
          day = '0' + patient.day
        }
        return month + '/' + day + '/' + patient.year
      } else {
        return ''
      }
    },
    formatTimeWithAmPm (time) {
      let time2 = time
      if (typeof time2 !== 'undefined' && time2 !== 'undefined' && time2 !== null) {
        let newTime = moment(time2).format('MM/DD/YYYY H:mm A')
        if (moment(time).isValid()) {
          return moment(time2).format('MM/DD/YYYY H:mm A')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatFullTime (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return moment(time).format('MM/DD/YYYY hh:mm')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatTime (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return newTime
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    roundingWithFloat (number) {
      if (number) {
        return number.toFixed(2)
      }
      return number
    },
    formatTimeSignature (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(new Date(time)).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return newTime
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatOnlyTime (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return moment(time).format('hh:mm')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatFullTime12Hour (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return moment(time).format('MM/DD/YYYY hh:mm A')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatOnlyTime12Hour (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return moment(time).format('hh:mm A')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    getExpireTime (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        if (time.length === 6) {
          if (time.substr(4, 2) === '00') {
            // time = 230100 => 2023 01 31
            time = time.substr(0, 4) + '01'
            return moment(time, 'YYMMDD').endOf('month')
          }
          let newTime = moment(time, 'YYMMDD').format('MM/DD/YYYY')
          return newTime
        }
      }
      return time
    },
    formatDobWithAge (patient) {
      //        March 11th, 1987 (Age 29)
      let dateString = patient.month + '/' + patient.day + '/' + patient.year
      let age = (new Date()).getFullYear() - patient.year
      return moment(dateString, 'M/D/Y').format('MM/DD/YYYY') + ' (Age ' + age + ')'
    },
    calculateAgePatient (patient) {
      if (patient.year) {
        return (new Date()).getFullYear() - patient.year
      }
      return 7
    },
    showNameBill (bill) {
      let name = ''
      if (bill) {
        name += this.formatTime(bill.time)
        if (bill.appointmentTypeAbbreviation) {
          name += ' - ' + bill.appointmentTypeAbbreviation
        }
        name += ' #' + bill.mrn
        if (bill.doctor && bill.doctor.fullName) {
          name += ' -' + bill.doctor.fullName
        }
        if (bill.location && bill.location.name) {
          name += ' -' + bill.location.name
        }
      }
      return name
    },
    formatTimeMessage (time) {
      let time2 = time
      if (time2 !== '' && typeof time2 !== 'undefined' && time2 !== 'undefined' && time2 !== null) {
        let newTime = moment(time2).format('MM/DD/YYYY H:mm')
        if (newTime !== '01/01/1970') {
          return newTime
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatTimeWithHour (time) {
      let time2 = time
      if (typeof time2 !== 'undefined' && time2 !== 'undefined' && time2 !== null) {
        if (moment(time).isValid()) {
          return moment(time2).format('hh:mm A')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatTimeRequestOff (time) {
      return moment(time, 'YYYYMMDD').format('MM/DD/YYYY')
    },
    groupByBill (data) {
      let i = 0
      let values = []
      for (; i < data.length; i++) {
        let item = data[i]
        // group fee data

        if (item['cpt'] !== undefined) {
          let checked = -1
          values.some((value, key) => {
            if (value.cpt.toString() === item['cpt']) {
              checked = key
              return true
            }
          })
          if (checked > -1) {
            values[checked].fQ = Number(values[checked].fQ) + Number(item.fQ)
          } else {
            values.push(item)
          }
        } else {
          if (item['cid'] !== undefined) {
            let checked = -1
            values.some((value, key) => {
              if (value.cid.toString() === item['cid']) {
                checked = key
                return true
              }
            })
            if (checked > -1) {
              values[checked].fQ = Number(values[checked].fQ) + Number(item.fQ)
            } else {
              values.push(item)
            }
          }
        }
      }
      return values
    },
    showNameBillAppointment (bill) {
      if (bill) {
        return 'Billing #' + bill.mrn
      }
      return ''
    },
    showFormDelete () {
      return this.$store.state.infoFormDelete
    },

    formatStringToView (number, view = 1, prefix = true, excludeBalance = false) {
      // excludeBalance: là những cột không tính vào balance, Boss muốn show là (xx.yy)
      if (view && !isNaN(Number(number))) {
        let minus = false
        number = Number(number) // .toFixed(2)
        if (number < 0) {
          minus = true
          number = -1 * number
        }
        number = number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        let prefixText = ''
        if (prefix) {
          prefixText = minus ? '-$' : '$'
        }
        if (excludeBalance) { return '(' + prefixText + number + ')' }
        return prefixText + number
      } else if (!isNaN(Number(number))) {
        return Number(number)
      } else {
        return number
      }
    },
    formatAddValue (number) {
      if (!isNaN(Number(number))) {
        number = Number(number)
        if (number < 0) {
          number = -1 * number
        }
        return number
      } else if (!isNaN(Number(number))) {
        return Number(number)
      } else {
        return number
      }
    },
    getNameMedicationWithFormat (medication, showRefill = true) {
      let nameMedication = medication.name

      if (medication.strength) {
        nameMedication += ' ' + medication.strength + ', '
      }

      if (medication.dose) {
        nameMedication += medication.dose + ' '
      }

      if (medication.doseUnit) {
        nameMedication += medication.doseUnit + ', '
      }
      if (medication.routeName) {
        nameMedication += medication.routeName + ' '
      }
      if (medication.frequencyName) {
        nameMedication += medication.frequencyName
      }

      if (medication.pRN || medication.prn) {
        nameMedication += ' PRN'
      }

      if (medication.quantity) {
        nameMedication += '. Dispense ' + medication.quantity
      }
      if (medication.unit) {
        nameMedication += ' ' + medication.unit
      }
      if (medication.refill && showRefill) {
        nameMedication += '. Refill ' + medication.refill
      }
      return nameMedication
    },
    formatAvatar (link) {
      return baseUrl + link
    },
    formatAvatarUser (link) {
      return wikiUrl + link
    },

    doDataPft (value1, value2) {
      if (value1 && value2) {
        return (value1 / value2).toFixed(2)
      }

      return ''
    },
    showAnaName (vital) {
      let string = []
      if (vital.anaphylaxis) {
        let ana = vital.anaphylaxis
        ana = ana.filter(function (x) {
          return x.check
        })
        ana.map(a => {
          let name = a.name
          if (a.dose) {
            name += ' (' + a.dose + ' ' + a.unit + ')'
          }
          string.push(name)
        })
      }
      if (string.length) {
        return string.join(', ')
      }
      return ''
    },
    showNameOrderVaccineSelect (order) {
      //        08/18/2018 Environmental panel - Adult
      if (order) {
        return this.formatTime(order.mixOrderTime) + ' ' + order.skinTestName
      }
      return ''
    },
    showNameMixFull (mix) {
      let string = mix.typeOrder + '- Mixed on ' + this.formatTime(mix.mixingDate)
      if (mix.insuranceCarrier) {
        string += ', INS: ' + mix.insuranceCarrier
      }
      return string
    },
    validateEmail (email) {
      var emailReg = /^([\w-]+@([\w-]+\.)+[\w-]{2,4})?$/
      return emailReg.test(email)
    },
    formatPhone (phone) {
      if (phone) {
        if (phone.length === 10) { return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') } else { return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4') }
      }
      return ''
    },
    formatDateTimeAt (time) {
      if (time && time !== '') {
        let date = new Date(time)

        return moment(time).format('MM/DD/YYYY [at] HH:mm A')
      } else {
        return 'N/A'
      }
    },
    checkPermissionCreateOrderVaccine () {
      if (this.$store.getters.user) {
        let index = this.storeUserPermissions.indexOf('MidLevel')

        if (this.$store.getters.user.role === 'physician' ||
            this.$store.getters.user.role === 'allergist' || index >= 0) {
          return true
        }
      }
      return false
    },

    checkPermissionCreateBiologic () {
      if (this.$store.getters.user) {
        let index = this.storeUserPermissions.indexOf('MidLevel')
        if (this.$store.getters.user.role === 'physician' ||
            this.$store.getters.user.role === 'allergist' || index >= 0) {
          return true
        }
      }
      return false
    },

    getPetPatients (pets) {
      let result = ''
      if (pets && pets.length > 0) {
        pets.map(pet => {
          if (pet.name && pet.name !== 'None') {
            if (result) {
              result += ', '
            }
            result += pet.name
            if (pet.number) {
              result += ' (' + pet.number + ')'
            }
          } else {
            result = 'None'
          }
        })
      }

      return result
    },

    formatObservation (injection, reaction) {
      if (reaction && injection) {
        let inj = moment(injection)
        let react = moment(reaction)
        let diff = react.diff(inj, 'seconds')
        if (diff < 60) {
          return diff + 's'
        } else {
          let minute = Math.floor(diff / 60)
          let second = diff % 60
          if (second) {
            return minute + 'm' + ' ' + second + 's'
          }
          return minute + 'm'
        }
      }
      return '0m 0s'
    },
    formatVialSign (vitalSigns) {

    },
    titleDelete (name = '') {
      return config.INFO_FORM_DELETE.contentDeleteForm + (name ? ('"' + name + '"') : ' this record') + '?'
    },
    checkRoleMenu (...permissions) {
      if (this.storeUser.role === 'AllergyClinic') {
        return true
      }
      if (permissions && permissions instanceof Array && permissions.length > 0) {
        let requiredPermissions = permissions
        let userPermission = this.storeUserPermissions
        let checkPermission = true
        requiredPermissions.map(per => {
          if (userPermission.indexOf(per) < 0) {
            checkPermission = false
          }
        })
        return checkPermission
      }
      return false
    },
    checkPermissionClinic () {
      if (this.storeUser && (this.storeUser.clinicIdWiki === 4 || this.storeUser.ownerId === '5c36d96a0b7513d59d1005d8' || this.storeUser.id === '5c36d96a0b7513d59d1005d8')) {
        return true
      }
      return false
    },
    formatAvatarConversation (url) {
      if (url) {
        return wikiUrl + '/' + url
      }
      return ''
    }
  }
}
</script>
